import { React, DomeComponent, DomeManipulator } from '@lexriver/dome'
import css from './Autocomplete.m.scss'
import { ErrorForInput } from './ErrorForInput'
import { debounce } from 'ts-debounce'


interface Attrs{
    placeholder?:string
    autocompleteFunctionAsync:(typedText:string)=>Promise<string[]>
    value?:string
    onEnterKeypress?:()=>void
    maxItems?:number
    delayMs?:number
    onSelectItem?:(text:string)=>void
    sessionStorageKey?:string
}
export class Autocomplete extends DomeComponent<Attrs>{
    private errorForInput:ErrorForInput|undefined 
    private input:HTMLInputElement|undefined
    private divAutocomplete:HTMLDivElement|undefined
    render(){
        if(this.attrs.sessionStorageKey){
            this.attrs.value = sessionStorage.getItem(this.attrs.sessionStorageKey)||this.attrs.value||''
        }
        return (
            <div class={css.autocomplete}>
                <input 
                    type='text' 
                    onInput={(e) => this.onInputAsync(e)} 
                    onBlur={() => this.onBlur()}
                    value={this.attrs.value || ''} 
                    ref={(ref:HTMLInputElement) => {               this.input = ref        }}
                    placeholder={this.attrs.placeholder}
                />
                <ErrorForInput ref={ref => this.errorForInput = ref} />
                <div class={css.autocomplete} ref={ref => this.divAutocomplete = ref} style={{display:'none'}}>
                </div>
            </div>
        )
    }


    protected selectedIndex:number = -1
    afterRender(){
        if(!this.input) return
        this.input.addEventListener('keydown', (e) => {
            if(!this.divAutocomplete) return
            if(this.divAutocomplete.style.display == 'none') return
            //console.log('keydown', 'e=', e)
            if(e.key == 'ArrowUp'){
                e.preventDefault()
                this.select(this.selectedIndex-1)

            } else if(e.key == 'ArrowDown'){
                e.preventDefault()
                this.select(this.selectedIndex+1)

            } else if(e.key == 'Enter'){
                this.setTextBySelectedItem()
                this.hideAutocomplete()

            } else if(e.key == 'Tab'){
                this.setTextBySelectedItem()
                this.hideAutocomplete()

            }
        })
        this.input.addEventListener('blur', () => {
            //setTimeout(() => {
                this.hideAutocomplete()
            //}, 500)

            
        })
    }

    protected hideAutocomplete(){
        if(!this.divAutocomplete) return
        this.divAutocomplete.style.display = 'none'
    }

    protected showAutocomplete(){
        if(!this.divAutocomplete) return
        if(document.activeElement !== this.input) return
        this.divAutocomplete.style.display = 'block'
    }

    protected setTextBySelectedItem(){
        //console.log('setting text by selected item')
        if(!this.input) return
        if(!this.divAutocomplete) return
        if(this.selectedIndex < 0) return 
        if(this.selectedIndex >= this.divAutocomplete.childElementCount) return
        const newValue = this.divAutocomplete.children[this.selectedIndex].textContent
        //console.log('newValue=', newValue)
        if(!newValue) return
        this.input.value = newValue
        this.attrs.value = newValue
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, this.attrs.value)
        }
        if(this.attrs.onSelectItem){
            this.attrs.onSelectItem(newValue) // call attrs method
        }

        this.input.focus()
        //console.log('focus!')
        setTimeout(() => {
            this.input && this.input.focus()
        }, 10)


    }

    protected deselectAll(){
        if(!this.divAutocomplete) return
        for(let i = 0; i < this.divAutocomplete.children.length; i++){
            this.divAutocomplete.children[i].classList.remove(css.selected)
        }
        this.selectedIndex = -1
    }

    protected select(index:number){
        if(!this.divAutocomplete) return
        this.deselectAll()
        if(index >= 0 && index < this.divAutocomplete.childElementCount){
            this.divAutocomplete.children[index].classList.add(css.selected)
        }
        this.selectedIndex = index
    }

    protected async onInputAsync(e){
        //console.log('on input', e.target.value)
        const typedText = e.target.value
        this.attrs.value = typedText
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, this.attrs.value || '')
        }
        await this.hideErrorAsync()
        //this.updateAutocompleteAsync(typedText)
        this.updateAutocompleteAsyncDebounced(typedText)
        
    }

    protected onBlur(){
        this.hideAutocomplete()
    }

    protected updateAutocompleteAsyncDebounced = debounce(this.updateAutocompleteAsync, this.attrs.delayMs || 500)

    protected async updateAutocompleteAsync(text:string){
        if(!this.divAutocomplete) return
        let autocompleteItems = await this.attrs.autocompleteFunctionAsync(text)

        if(this.attrs.maxItems && this.attrs.maxItems>0 && autocompleteItems.length>this.attrs.maxItems){
            // cut if too much items
            autocompleteItems = autocompleteItems.splice(this.attrs.maxItems)
        }

        if(autocompleteItems.length>0){
            // show autocomplete
            await DomeManipulator.removeAllChildrenAsync(this.divAutocomplete)
            
            //for(let item of autocompleteItems){
            for(let i = 0; i<autocompleteItems.length; i++){
                let item = autocompleteItems[i]
                item = this.highlightAll(item, text)
                //console.log('item=', item)
                const div:HTMLInputElement = <div></div>

                div.addEventListener('mouseenter', () => {
                    this.select(i)
                })

                div.addEventListener('mousedown', () => {
                    this.setTextBySelectedItem()
                })

                div.innerHTML = item
                this.divAutocomplete.appendChild(div)
            }
            this.showAutocomplete()
            

        } else {
            this.hideAutocomplete()
        }
        this.selectedIndex = -1
    }

    protected highlightAll(text:string, query:string) {
        //return text.replace(new RegExp(this.escapeRegExp(query), 'ig'), '<strong>'+query+'</strong>');
        return text.replace(new RegExp(this.escapeRegExp(query), 'ig'), "<strong>$&</strong>");
    }

    protected escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }

    async hideErrorAsync(){
        if(!this.errorForInput) return
        await this.errorForInput.hideAsync()
    }

    async showErrorAsync(errorMessage:string|HTMLElement){
        if(!this.errorForInput) return
        await this.errorForInput.showAsync(errorMessage)
        if(!this.input) return
        DomeManipulator.scrollIntoView(this.input)
    }

    getValue(){
        //return this.attrs.value
        if(!this.input) return ''
        return this.input.value
    }

    setValue(value:string){
        if(!this.input) return
        this.input.value = value || ''
        this.attrs.value = this.input.value
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, this.attrs.value)
        }
        this.hideAutocomplete()
    }

    clear(){
        this.setValue('')
    }

    focus(){
        if(this.input) this.input.focus()
    }

    disable(){
        if(this.input) this.input.disabled = true
        this.hideAutocomplete()
    }

    enable(){
        if(this.input) this.input.disabled = false
    }
    
}